// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--AuDs1","fadeSlideUp":"fadeSlideUp--bga5y"};